import { render, staticRenderFns } from "./LSelectFile.vue?vue&type=template&id=3fafea60&scoped=true"
import script from "./LSelectFile.vue?vue&type=script&lang=js"
export * from "./LSelectFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafea60",
  null
  
)

export default component.exports